// extracted by mini-css-extract-plugin
export default {"actionsHeadCell":"wallet-full_actionsHeadCell__Ltj2a","walletActions":"wallet-full_walletActions__+hL9J"};